import {
  Box,
  Center,
  Heading,
  Inline,
  Stack,
  Text,
  TypographyHeadingLevel,
  useTheme
} from "@seneca/senekit";

export enum TimeUnits {
  DAYS = "DAYS",
  HOURS = "HOURS",
  MINUTES = "MINUTES",
  SECONDS = "SECONDS"
}

export type Dimensions = {
  blockContainer: { width: string; height: string };
  numberContainer: { width: string; height: string };
  numberSize: TypographyHeadingLevel;
  dividerSize?: [TypographyHeadingLevel, TypographyHeadingLevel];
};

type Props = {
  timeUnit: TimeUnits;
  timeValue: string;
  dimensions?: Dimensions;
  backgroundColor?: string;
  simple?: boolean;
};

const defaultValues: Dimensions = {
  blockContainer: { width: "52px", height: "41px" },
  numberContainer: { width: "24px", height: "28px" },
  numberSize: "5"
};

export default function TimerBlock({
  timeUnit,
  timeValue,
  dimensions = defaultValues,
  backgroundColor,
  simple = false
}: Props) {
  const theme = useTheme();
  const background = backgroundColor ? backgroundColor : theme.foreground;

  const [firstValue, secondValue] = timeValue.split("");

  const { blockContainer, numberContainer, numberSize } = dimensions;

  return (
    <>
      {simple ? (
        <Inline>
          <Heading level="3" weight="normal">
            {timeValue}
            {timeUnit.charAt(0).toLowerCase()}
          </Heading>
        </Inline>
      ) : (
        <Box width={blockContainer.width} height={blockContainer.height}>
          <Stack space="xxsmall">
            <Inline space="small">
              <Box
                width={numberContainer.width}
                height={numberContainer.height}
                borderRadius="small"
                background={background}
              >
                <Center>
                  <Heading level={numberSize} align="center">
                    {firstValue}
                  </Heading>
                </Center>
              </Box>
              <Box
                width={numberContainer.width}
                height={numberContainer.height}
                borderRadius="small"
                background={background}
              >
                <Center>
                  <Heading level={numberSize} align="center">
                    {secondValue}
                  </Heading>
                </Center>
              </Box>
            </Inline>
            <Text size="xsmall" align="center">
              {timeUnit}
            </Text>
          </Stack>
        </Box>
      )}
    </>
  );
}
